import { Component, Input, ViewChild } from '@angular/core';
import { BaseEntity } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { EnumPageDisplayModes, EnumPageEntitySources } from '@core/framework/sysenums.enum';
import { SignBoxComponent } from '@ui/dialogs/signbox-dialog/signbox/signbox.component';

class State {
    OkText: string;
    ClientWidth: number;
    ClientHeight: number;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-signboxdialog',
    templateUrl: './signboxdialog.component.html',
    styleUrls: ['./signboxdialog.component.scss']
})
export class SignBoxDialogComponent extends BasePageComponent<BaseEntity, State> {
    @ViewChild(SignBoxComponent) signBox: SignBoxComponent;
    @Input() Title: string;
    @Input() OkButtonText: string;
    @Input() MaxSignatureHeight = 0;
    @Input() SignatureReadOnly: boolean;

    constructor(A: ServiceBagService) {
        super(A, 'SignBoxDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    // Main property to store the data. Since additional operation needs to take place, use this method instead of state directly
    public set SignatureData(value: string) {
        this.signBox.SignatureData = value;
    }

    public get SignatureData(): string {
        return this.signBox.SignatureData;
    }

    protected override OnInitTitle(): string {
        return this.Title;
    }

    protected override OnInitComponentFinished() {
        if (this.OkButtonText !== undefined) {
            this.State.OkText = this.OkButtonText;
        } else {
            this.State.OkText = this.RC('genSign');
        }
        this.SetClientSizes();
    }

    OnResetPad() {
        this.signBox.ClearSignature();
    }

    // Save
    OnSaveSignature() {
        if (!this.SignatureReadOnly) {
            // Make sure signature exists
            if (this.signBox.IsEmpty()) {
                this.UI.StopMessage(this.RC('msgSignatureRequired'), '#pad');
                return;
            }

            // Save and close
            this.signBox.Save();
            this.CloseDialogWithSuccess(this.SignatureData);
        } else {
            this.CloseDialogWithCancel();
        }
    }

    private GetCanvasWidth(): number {
        return document.querySelector('.signbox-container')?.getBoundingClientRect()?.width - 3 || 0;
    }

    private SetClientSizes() {
        setTimeout(() => {
            this.State.ClientWidth = this.GetCanvasWidth();
            this.State.ClientHeight = window.innerHeight / 2;
        }, 400);
        // wait for animation, TODO: figure out how to subscribe to complete animation template
    }
}
